// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../vninvestcharts-widget/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../vninvestcharts-widget/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * SettingsModal.module.css
 * TradingView-parity 2-column responsive layout for Chart Settings
 */
.zl4G_f4VeLUZDgv9LLPn {
	position: fixed;
	inset: 0;
	z-index: 10000;
	display: flex;
	align-items: center;
	justify-content: center;
	background: rgba(0, 0, 0, 0.65);
	backdrop-filter: blur(2px);
}

.vnsc-root[data-chart-mode="light"] .zl4G_f4VeLUZDgv9LLPn {
	background: rgba(15, 23, 42, 0.35);
}

.WNntVc3SV9ejG1YMkpBn {
	width: 820px;
	max-width: 95vw;
	height: 620px;
	max-height: 90vh;
	display: flex;
	flex-direction: column;
	background: var(--vnsc-bg-primary, #0f1720);
	color: var(--vnsc-text-primary, #f1f5f9);
	border: 1px solid var(--vnsc-border, #1e293b);
	border-radius: 8px;
	box-shadow: 0 16px 40px rgba(0, 0, 0, 0.4);
	overflow: hidden;
	box-sizing: border-box;
}

.aWE4A0br_5qtOM_j8k6P {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 12px 18px;
	border-bottom: 1px solid var(--vnsc-border, #1e293b);
	background: var(--vnsc-bg-secondary, #131d2a);
	flex-shrink: 0;
}

.EHeNNhD5TZJ7yonBOZ3e {
	font-size: 15px;
	font-weight: 600;
	color: var(--vnsc-text-primary, #f1f5f9);
	margin: 0;
	display: flex;
	align-items: center;
	gap: 8px;
	flex-wrap: wrap;
}

.pBlkQaa9EZm6l6mfGxWn {
	font-size: 11px;
	font-weight: 600;
	padding: 2px 8px;
	border-radius: 999px;
	background: var(--vnsc-accent-subtle, rgba(37, 99, 235, 0.12));
	color: var(--vnsc-accent, #38bdf8);
	border: 1px solid var(--vnsc-accent, #38bdf8);
	white-space: nowrap;
}

.BcW356b7atMshgT4foQA {
	background: transparent;
	border: none;
	color: var(--vnsc-text-secondary, #94a3b8);
	cursor: pointer;
	font-size: 18px;
	line-height: 1;
	padding: 4px 8px;
	border-radius: 4px;
	transition: all 0.15s ease;
}

.BcW356b7atMshgT4foQA:hover {
	background: var(--vnsc-bg-hover, rgba(255, 255, 255, 0.08));
	color: var(--vnsc-text-primary, #ffffff);
}

.DdSkpKRGSpjUTUD3f4ZL {
	display: flex;
	flex: 1;
	min-height: 0;
	overflow: hidden;
}

.DJrEh5bVH9OR4Jja3kBg {
	width: 220px;
	flex-shrink: 0;
	border-right: 1px solid var(--vnsc-border, #1e293b);
	background: var(--vnsc-bg-secondary, #131d2a);
	display: flex;
	flex-direction: column;
}

.dJWqlSQkvzdlBZ8xvauz {
	padding: 10px 12px;
	border-bottom: 1px solid var(--vnsc-border, #1e293b);
}

.rMHpnzD_eVvSKCKVsxmk {
	width: 100%;
	padding: 7px 10px;
	border-radius: 4px;
	border: 1px solid var(--vnsc-border, #1e293b);
	background: var(--vnsc-bg-primary, #0f1720);
	color: var(--vnsc-text-primary, #f1f5f9);
	font-size: 12px;
	box-sizing: border-box;
	outline: none;
}

.rMHpnzD_eVvSKCKVsxmk:focus {
	border-color: var(--vnsc-accent, #38bdf8);
}

.XiyhsOb1xq4P3L9rFmp5 {
	flex: 1;
	overflow-y: auto;
	padding: 6px 0;
	margin: 0;
	list-style: none;
}

.I64Hqkz95y9rPiT2HfBq {
	display: flex;
	align-items: center;
	gap: 10px;
	width: 100%;
	padding: 10px 16px;
	font-size: 13px;
	font-weight: 500;
	color: var(--vnsc-text-secondary, #94a3b8);
	background: transparent;
	border: none;
	text-align: left;
	cursor: pointer;
	transition: all 0.15s ease;
	border-left: 3px solid transparent;
	box-sizing: border-box;
}

.I64Hqkz95y9rPiT2HfBq:hover {
	background: var(--vnsc-bg-hover, rgba(255, 255, 255, 0.05));
	color: var(--vnsc-text-primary, #f1f5f9);
}

.lV2cs7FFWeOMWGFK1ig3 {
	background: var(--vnsc-accent-subtle, rgba(37, 99, 235, 0.12)) !important;
	color: var(--vnsc-accent, #38bdf8) !important;
	font-weight: 600;
	border-left-color: var(--vnsc-accent, #38bdf8) !important;
}

.tjZZpZRR1JFWZCMpRp0N {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 16px;
	height: 16px;
	flex-shrink: 0;
}

.GOfDheOWmATQKO4aX6wi {
	flex: 1;
	min-width: 0;
	overflow-y: auto;
	padding: 20px 24px;
	background: var(--vnsc-bg-primary, #0f1720);
}

.GCGsBkwiZZtapuUMx0lp {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 12px 18px;
	border-top: 1px solid var(--vnsc-border, #1e293b);
	background: var(--vnsc-bg-secondary, #131d2a);
	flex-shrink: 0;
}

.FxYZVikiCgUmVIfaKyj9,
.ofj5_NndKmccoaAJwq22 {
	display: flex;
	align-items: center;
	gap: 10px;
}

.eIu4Rt9YBFdh8AehXnUa {
	background: transparent;
	border: 1px solid var(--vnsc-border, #1e293b);
	color: var(--vnsc-text-secondary, #94a3b8);
	padding: 6px 14px;
	border-radius: 4px;
	font-size: 12px;
	cursor: pointer;
	transition: all 0.15s ease;
}

.eIu4Rt9YBFdh8AehXnUa:hover {
	background: var(--vnsc-bg-hover, rgba(255, 255, 255, 0.08));
	color: var(--vnsc-text-primary, #f1f5f9);
}

.drD1FEZR1AbuM90aG09Q {
	background: transparent;
	border: 1px solid var(--vnsc-accent, #38bdf8);
	color: var(--vnsc-accent, #38bdf8);
	padding: 6px 14px;
	border-radius: 4px;
	font-size: 12px;
	font-weight: 600;
	cursor: pointer;
	transition: all 0.15s ease;
	white-space: nowrap;
}

.drD1FEZR1AbuM90aG09Q:hover {
	background: var(--vnsc-accent-subtle, rgba(37, 99, 235, 0.12));
}

.q5Q5HpcF8sTmdeKCM_wv {
	background: transparent;
	border: 1px solid var(--vnsc-border, #1e293b);
	color: var(--vnsc-text-primary, #f1f5f9);
	padding: 7px 16px;
	border-radius: 4px;
	font-size: 13px;
	cursor: pointer;
	transition: all 0.15s ease;
}

.q5Q5HpcF8sTmdeKCM_wv:hover {
	background: var(--vnsc-bg-hover, rgba(255, 255, 255, 0.08));
}

.dLVe4ZWpKAhIPpEC5V6E {
	background: var(--vnsc-accent, #2563eb);
	border: none;
	color: #ffffff;
	padding: 7px 20px;
	border-radius: 4px;
	font-size: 13px;
	font-weight: 600;
	cursor: pointer;
	transition: all 0.15s ease;
}

.dLVe4ZWpKAhIPpEC5V6E:hover {
	opacity: 0.9;
}

/* Mobile Responsiveness (<= 640px) */
@media (max-width: 640px) {
	.WNntVc3SV9ejG1YMkpBn {
		width: 100vw;
		height: 100vh;
		max-width: 100vw;
		max-height: 100vh;
		border-radius: 0;
		border: none;
	}

	.DdSkpKRGSpjUTUD3f4ZL {
		flex-direction: column;
	}

	.DJrEh5bVH9OR4Jja3kBg {
		width: 100%;
		max-height: 140px;
		border-right: none;
		border-bottom: 1px solid var(--vnsc-border, #1e293b);
	}

	.XiyhsOb1xq4P3L9rFmp5 {
		display: flex;
		overflow-x: auto;
		padding: 4px 8px;
		gap: 6px;
	}

	.I64Hqkz95y9rPiT2HfBq {
		width: auto;
		white-space: nowrap;
		border-left: none;
		border-bottom: 3px solid transparent;
		min-height: 44px;
		padding: 8px 12px;
	}

	.lV2cs7FFWeOMWGFK1ig3 {
		border-left-color: transparent !important;
		border-bottom-color: var(--vnsc-accent, #38bdf8) !important;
	}

	.GOfDheOWmATQKO4aX6wi {
		padding: 14px;
	}

	.eIu4Rt9YBFdh8AehXnUa,
	.q5Q5HpcF8sTmdeKCM_wv,
	.dLVe4ZWpKAhIPpEC5V6E {
		min-height: 44px;
	}
}

`, "",{"version":3,"sources":["webpack://./src/widget/components/settings/SettingsModal.module.css"],"names":[],"mappings":"AAAA;;;EAGE;AACF;CACC,eAAe;CACf,QAAQ;CACR,cAAc;CACd,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,+BAA+B;CAC/B,0BAA0B;AAC3B;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,YAAY;CACZ,eAAe;CACf,aAAa;CACb,gBAAgB;CAChB,aAAa;CACb,sBAAsB;CACtB,2CAA2C;CAC3C,wCAAwC;CACxC,6CAA6C;CAC7C,kBAAkB;CAClB,0CAA0C;CAC1C,gBAAgB;CAChB,sBAAsB;AACvB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,8BAA8B;CAC9B,kBAAkB;CAClB,oDAAoD;CACpD,6CAA6C;CAC7C,cAAc;AACf;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,wCAAwC;CACxC,SAAS;CACT,aAAa;CACb,mBAAmB;CACnB,QAAQ;CACR,eAAe;AAChB;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,gBAAgB;CAChB,oBAAoB;CACpB,8DAA8D;CAC9D,kCAAkC;CAClC,6CAA6C;CAC7C,mBAAmB;AACpB;;AAEA;CACC,uBAAuB;CACvB,YAAY;CACZ,0CAA0C;CAC1C,eAAe;CACf,eAAe;CACf,cAAc;CACd,gBAAgB;CAChB,kBAAkB;CAClB,0BAA0B;AAC3B;;AAEA;CACC,2DAA2D;CAC3D,wCAAwC;AACzC;;AAEA;CACC,aAAa;CACb,OAAO;CACP,aAAa;CACb,gBAAgB;AACjB;;AAEA;CACC,YAAY;CACZ,cAAc;CACd,mDAAmD;CACnD,6CAA6C;CAC7C,aAAa;CACb,sBAAsB;AACvB;;AAEA;CACC,kBAAkB;CAClB,oDAAoD;AACrD;;AAEA;CACC,WAAW;CACX,iBAAiB;CACjB,kBAAkB;CAClB,6CAA6C;CAC7C,2CAA2C;CAC3C,wCAAwC;CACxC,eAAe;CACf,sBAAsB;CACtB,aAAa;AACd;;AAEA;CACC,yCAAyC;AAC1C;;AAEA;CACC,OAAO;CACP,gBAAgB;CAChB,cAAc;CACd,SAAS;CACT,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,SAAS;CACT,WAAW;CACX,kBAAkB;CAClB,eAAe;CACf,gBAAgB;CAChB,0CAA0C;CAC1C,uBAAuB;CACvB,YAAY;CACZ,gBAAgB;CAChB,eAAe;CACf,0BAA0B;CAC1B,kCAAkC;CAClC,sBAAsB;AACvB;;AAEA;CACC,2DAA2D;CAC3D,wCAAwC;AACzC;;AAEA;CACC,yEAAyE;CACzE,6CAA6C;CAC7C,gBAAgB;CAChB,yDAAyD;AAC1D;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,WAAW;CACX,YAAY;CACZ,cAAc;AACf;;AAEA;CACC,OAAO;CACP,YAAY;CACZ,gBAAgB;CAChB,kBAAkB;CAClB,2CAA2C;AAC5C;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,8BAA8B;CAC9B,kBAAkB;CAClB,iDAAiD;CACjD,6CAA6C;CAC7C,cAAc;AACf;;AAEA;;CAEC,aAAa;CACb,mBAAmB;CACnB,SAAS;AACV;;AAEA;CACC,uBAAuB;CACvB,6CAA6C;CAC7C,0CAA0C;CAC1C,iBAAiB;CACjB,kBAAkB;CAClB,eAAe;CACf,eAAe;CACf,0BAA0B;AAC3B;;AAEA;CACC,2DAA2D;CAC3D,wCAAwC;AACzC;;AAEA;CACC,uBAAuB;CACvB,6CAA6C;CAC7C,kCAAkC;CAClC,iBAAiB;CACjB,kBAAkB;CAClB,eAAe;CACf,gBAAgB;CAChB,eAAe;CACf,0BAA0B;CAC1B,mBAAmB;AACpB;;AAEA;CACC,8DAA8D;AAC/D;;AAEA;CACC,uBAAuB;CACvB,6CAA6C;CAC7C,wCAAwC;CACxC,iBAAiB;CACjB,kBAAkB;CAClB,eAAe;CACf,eAAe;CACf,0BAA0B;AAC3B;;AAEA;CACC,2DAA2D;AAC5D;;AAEA;CACC,uCAAuC;CACvC,YAAY;CACZ,cAAc;CACd,iBAAiB;CACjB,kBAAkB;CAClB,eAAe;CACf,gBAAgB;CAChB,eAAe;CACf,0BAA0B;AAC3B;;AAEA;CACC,YAAY;AACb;;AAEA,qCAAqC;AACrC;CACC;EACC,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;CACb;;CAEA;EACC,sBAAsB;CACvB;;CAEA;EACC,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,oDAAoD;CACrD;;CAEA;EACC,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,QAAQ;CACT;;CAEA;EACC,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,oCAAoC;EACpC,gBAAgB;EAChB,iBAAiB;CAClB;;CAEA;EACC,yCAAyC;EACzC,2DAA2D;CAC5D;;CAEA;EACC,aAAa;CACd;;CAEA;;;EAGC,gBAAgB;CACjB;AACD","sourcesContent":["/**\r\n * SettingsModal.module.css\r\n * TradingView-parity 2-column responsive layout for Chart Settings\r\n */\r\n.backdrop {\r\n\tposition: fixed;\r\n\tinset: 0;\r\n\tz-index: 10000;\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tjustify-content: center;\r\n\tbackground: rgba(0, 0, 0, 0.65);\r\n\tbackdrop-filter: blur(2px);\r\n}\r\n\r\n:global(.vnsc-root[data-chart-mode=\"light\"]) .backdrop {\r\n\tbackground: rgba(15, 23, 42, 0.35);\r\n}\r\n\r\n.modalShell {\r\n\twidth: 820px;\r\n\tmax-width: 95vw;\r\n\theight: 620px;\r\n\tmax-height: 90vh;\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n\tbackground: var(--vnsc-bg-primary, #0f1720);\r\n\tcolor: var(--vnsc-text-primary, #f1f5f9);\r\n\tborder: 1px solid var(--vnsc-border, #1e293b);\r\n\tborder-radius: 8px;\r\n\tbox-shadow: 0 16px 40px rgba(0, 0, 0, 0.4);\r\n\toverflow: hidden;\r\n\tbox-sizing: border-box;\r\n}\r\n\r\n.header {\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tjustify-content: space-between;\r\n\tpadding: 12px 18px;\r\n\tborder-bottom: 1px solid var(--vnsc-border, #1e293b);\r\n\tbackground: var(--vnsc-bg-secondary, #131d2a);\r\n\tflex-shrink: 0;\r\n}\r\n\r\n.headerTitle {\r\n\tfont-size: 15px;\r\n\tfont-weight: 600;\r\n\tcolor: var(--vnsc-text-primary, #f1f5f9);\r\n\tmargin: 0;\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tgap: 8px;\r\n\tflex-wrap: wrap;\r\n}\r\n\r\n.activeBadge {\r\n\tfont-size: 11px;\r\n\tfont-weight: 600;\r\n\tpadding: 2px 8px;\r\n\tborder-radius: 999px;\r\n\tbackground: var(--vnsc-accent-subtle, rgba(37, 99, 235, 0.12));\r\n\tcolor: var(--vnsc-accent, #38bdf8);\r\n\tborder: 1px solid var(--vnsc-accent, #38bdf8);\r\n\twhite-space: nowrap;\r\n}\r\n\r\n.closeBtn {\r\n\tbackground: transparent;\r\n\tborder: none;\r\n\tcolor: var(--vnsc-text-secondary, #94a3b8);\r\n\tcursor: pointer;\r\n\tfont-size: 18px;\r\n\tline-height: 1;\r\n\tpadding: 4px 8px;\r\n\tborder-radius: 4px;\r\n\ttransition: all 0.15s ease;\r\n}\r\n\r\n.closeBtn:hover {\r\n\tbackground: var(--vnsc-bg-hover, rgba(255, 255, 255, 0.08));\r\n\tcolor: var(--vnsc-text-primary, #ffffff);\r\n}\r\n\r\n.body {\r\n\tdisplay: flex;\r\n\tflex: 1;\r\n\tmin-height: 0;\r\n\toverflow: hidden;\r\n}\r\n\r\n.sidebar {\r\n\twidth: 220px;\r\n\tflex-shrink: 0;\r\n\tborder-right: 1px solid var(--vnsc-border, #1e293b);\r\n\tbackground: var(--vnsc-bg-secondary, #131d2a);\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n}\r\n\r\n.searchWrapper {\r\n\tpadding: 10px 12px;\r\n\tborder-bottom: 1px solid var(--vnsc-border, #1e293b);\r\n}\r\n\r\n.searchInput {\r\n\twidth: 100%;\r\n\tpadding: 7px 10px;\r\n\tborder-radius: 4px;\r\n\tborder: 1px solid var(--vnsc-border, #1e293b);\r\n\tbackground: var(--vnsc-bg-primary, #0f1720);\r\n\tcolor: var(--vnsc-text-primary, #f1f5f9);\r\n\tfont-size: 12px;\r\n\tbox-sizing: border-box;\r\n\toutline: none;\r\n}\r\n\r\n.searchInput:focus {\r\n\tborder-color: var(--vnsc-accent, #38bdf8);\r\n}\r\n\r\n.tabList {\r\n\tflex: 1;\r\n\toverflow-y: auto;\r\n\tpadding: 6px 0;\r\n\tmargin: 0;\r\n\tlist-style: none;\r\n}\r\n\r\n.tabItem {\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tgap: 10px;\r\n\twidth: 100%;\r\n\tpadding: 10px 16px;\r\n\tfont-size: 13px;\r\n\tfont-weight: 500;\r\n\tcolor: var(--vnsc-text-secondary, #94a3b8);\r\n\tbackground: transparent;\r\n\tborder: none;\r\n\ttext-align: left;\r\n\tcursor: pointer;\r\n\ttransition: all 0.15s ease;\r\n\tborder-left: 3px solid transparent;\r\n\tbox-sizing: border-box;\r\n}\r\n\r\n.tabItem:hover {\r\n\tbackground: var(--vnsc-bg-hover, rgba(255, 255, 255, 0.05));\r\n\tcolor: var(--vnsc-text-primary, #f1f5f9);\r\n}\r\n\r\n.tabItemActive {\r\n\tbackground: var(--vnsc-accent-subtle, rgba(37, 99, 235, 0.12)) !important;\r\n\tcolor: var(--vnsc-accent, #38bdf8) !important;\r\n\tfont-weight: 600;\r\n\tborder-left-color: var(--vnsc-accent, #38bdf8) !important;\r\n}\r\n\r\n.tabIcon {\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tjustify-content: center;\r\n\twidth: 16px;\r\n\theight: 16px;\r\n\tflex-shrink: 0;\r\n}\r\n\r\n.contentPanel {\r\n\tflex: 1;\r\n\tmin-width: 0;\r\n\toverflow-y: auto;\r\n\tpadding: 20px 24px;\r\n\tbackground: var(--vnsc-bg-primary, #0f1720);\r\n}\r\n\r\n.footer {\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tjustify-content: space-between;\r\n\tpadding: 12px 18px;\r\n\tborder-top: 1px solid var(--vnsc-border, #1e293b);\r\n\tbackground: var(--vnsc-bg-secondary, #131d2a);\r\n\tflex-shrink: 0;\r\n}\r\n\r\n.footerLeft,\r\n.footerRight {\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tgap: 10px;\r\n}\r\n\r\n.btnReset {\r\n\tbackground: transparent;\r\n\tborder: 1px solid var(--vnsc-border, #1e293b);\r\n\tcolor: var(--vnsc-text-secondary, #94a3b8);\r\n\tpadding: 6px 14px;\r\n\tborder-radius: 4px;\r\n\tfont-size: 12px;\r\n\tcursor: pointer;\r\n\ttransition: all 0.15s ease;\r\n}\r\n\r\n.btnReset:hover {\r\n\tbackground: var(--vnsc-bg-hover, rgba(255, 255, 255, 0.08));\r\n\tcolor: var(--vnsc-text-primary, #f1f5f9);\r\n}\r\n\r\n.btnApplyAll {\r\n\tbackground: transparent;\r\n\tborder: 1px solid var(--vnsc-accent, #38bdf8);\r\n\tcolor: var(--vnsc-accent, #38bdf8);\r\n\tpadding: 6px 14px;\r\n\tborder-radius: 4px;\r\n\tfont-size: 12px;\r\n\tfont-weight: 600;\r\n\tcursor: pointer;\r\n\ttransition: all 0.15s ease;\r\n\twhite-space: nowrap;\r\n}\r\n\r\n.btnApplyAll:hover {\r\n\tbackground: var(--vnsc-accent-subtle, rgba(37, 99, 235, 0.12));\r\n}\r\n\r\n.btnCancel {\r\n\tbackground: transparent;\r\n\tborder: 1px solid var(--vnsc-border, #1e293b);\r\n\tcolor: var(--vnsc-text-primary, #f1f5f9);\r\n\tpadding: 7px 16px;\r\n\tborder-radius: 4px;\r\n\tfont-size: 13px;\r\n\tcursor: pointer;\r\n\ttransition: all 0.15s ease;\r\n}\r\n\r\n.btnCancel:hover {\r\n\tbackground: var(--vnsc-bg-hover, rgba(255, 255, 255, 0.08));\r\n}\r\n\r\n.btnApply {\r\n\tbackground: var(--vnsc-accent, #2563eb);\r\n\tborder: none;\r\n\tcolor: #ffffff;\r\n\tpadding: 7px 20px;\r\n\tborder-radius: 4px;\r\n\tfont-size: 13px;\r\n\tfont-weight: 600;\r\n\tcursor: pointer;\r\n\ttransition: all 0.15s ease;\r\n}\r\n\r\n.btnApply:hover {\r\n\topacity: 0.9;\r\n}\r\n\r\n/* Mobile Responsiveness (<= 640px) */\r\n@media (max-width: 640px) {\r\n\t.modalShell {\r\n\t\twidth: 100vw;\r\n\t\theight: 100vh;\r\n\t\tmax-width: 100vw;\r\n\t\tmax-height: 100vh;\r\n\t\tborder-radius: 0;\r\n\t\tborder: none;\r\n\t}\r\n\r\n\t.body {\r\n\t\tflex-direction: column;\r\n\t}\r\n\r\n\t.sidebar {\r\n\t\twidth: 100%;\r\n\t\tmax-height: 140px;\r\n\t\tborder-right: none;\r\n\t\tborder-bottom: 1px solid var(--vnsc-border, #1e293b);\r\n\t}\r\n\r\n\t.tabList {\r\n\t\tdisplay: flex;\r\n\t\toverflow-x: auto;\r\n\t\tpadding: 4px 8px;\r\n\t\tgap: 6px;\r\n\t}\r\n\r\n\t.tabItem {\r\n\t\twidth: auto;\r\n\t\twhite-space: nowrap;\r\n\t\tborder-left: none;\r\n\t\tborder-bottom: 3px solid transparent;\r\n\t\tmin-height: 44px;\r\n\t\tpadding: 8px 12px;\r\n\t}\r\n\r\n\t.tabItemActive {\r\n\t\tborder-left-color: transparent !important;\r\n\t\tborder-bottom-color: var(--vnsc-accent, #38bdf8) !important;\r\n\t}\r\n\r\n\t.contentPanel {\r\n\t\tpadding: 14px;\r\n\t}\r\n\r\n\t.btnReset,\r\n\t.btnCancel,\r\n\t.btnApply {\r\n\t\tmin-height: 44px;\r\n\t}\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"backdrop": `zl4G_f4VeLUZDgv9LLPn`,
	"modalShell": `WNntVc3SV9ejG1YMkpBn`,
	"header": `aWE4A0br_5qtOM_j8k6P`,
	"headerTitle": `EHeNNhD5TZJ7yonBOZ3e`,
	"activeBadge": `pBlkQaa9EZm6l6mfGxWn`,
	"closeBtn": `BcW356b7atMshgT4foQA`,
	"body": `DdSkpKRGSpjUTUD3f4ZL`,
	"sidebar": `DJrEh5bVH9OR4Jja3kBg`,
	"searchWrapper": `dJWqlSQkvzdlBZ8xvauz`,
	"searchInput": `rMHpnzD_eVvSKCKVsxmk`,
	"tabList": `XiyhsOb1xq4P3L9rFmp5`,
	"tabItem": `I64Hqkz95y9rPiT2HfBq`,
	"tabItemActive": `lV2cs7FFWeOMWGFK1ig3`,
	"tabIcon": `tjZZpZRR1JFWZCMpRp0N`,
	"contentPanel": `GOfDheOWmATQKO4aX6wi`,
	"footer": `GCGsBkwiZZtapuUMx0lp`,
	"footerLeft": `FxYZVikiCgUmVIfaKyj9`,
	"footerRight": `ofj5_NndKmccoaAJwq22`,
	"btnReset": `eIu4Rt9YBFdh8AehXnUa`,
	"btnApplyAll": `drD1FEZR1AbuM90aG09Q`,
	"btnCancel": `q5Q5HpcF8sTmdeKCM_wv`,
	"btnApply": `dLVe4ZWpKAhIPpEC5V6E`
};
export default ___CSS_LOADER_EXPORT___;
